import { ReactNode } from 'react';
import { TbBuilding } from 'react-icons/tb';

import { WorkspaceResourceGlyph } from '@/shared/components/workspace-resources/WorkspaceResourceAvatar';

export const compactSql = (sql: string) => sql.trim().replace(/\s+/g, ' ');

export const formatRuntime = (runtimeMs: number | null) =>
    runtimeMs === null ? 'Not run' : `${(runtimeMs / 1000).toFixed(2)}s`;

export const buildTablePreviewSql = (tableName: string, limit: number) =>
    `SELECT *\nFROM ${tableName}\nLIMIT ${limit};`;

export const humanize = (value: string) =>
    value
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/[._-]+/g, ' ')
        .replace(/\b\w/g, (character) => character.toUpperCase());

export const TABLE_PRESENTATION: Record<string, { description: string; icon: ReactNode }> = {
    workspace: { description: 'Workspace identity and public configuration.', icon: <TbBuilding /> },
    dashboard: {
        description: 'Dashboards available in the active workspace.',
        icon: <WorkspaceResourceGlyph resource='dashboard' size='1rem' />,
    },
    report: {
        description: 'Reports the current member is permitted to read.',
        icon: <WorkspaceResourceGlyph resource='report' size='1rem' />,
    },
    list: {
        description: 'Structured workspace lists and safe metadata.',
        icon: <WorkspaceResourceGlyph resource='list' size='1rem' />,
    },
    investment: {
        description: 'Investment records visible to the current member.',
        icon: <WorkspaceResourceGlyph resource='investment' size='1rem' />,
    },
    memo: {
        description: 'Memo metadata without private document content.',
        icon: <WorkspaceResourceGlyph resource='memo' size='1rem' />,
    },
    pipeline: {
        description: 'Pipeline metadata and workflow configuration.',
        icon: <WorkspaceResourceGlyph resource='pipeline' size='1rem' />,
    },
    folder: {
        description: 'Folders used to organize workspace research.',
        icon: <WorkspaceResourceGlyph resource='folder' size='1rem' />,
    },
    task: {
        description: 'Task metadata without private descriptions.',
        icon: <WorkspaceResourceGlyph resource='task' size='1rem' />,
    },
};
